module.exports = __webpack_public_path__ + "static/media/live_broadcast.8d4158fc.svg";